import { ConditionSingleValueInput } from 'ui/queryBuilder/ConditionInput';
import {
  ConditionDatePicker,
  ConditionSingleValueStringSelect,
  ConditionSingleValueStringSelectWithButton,
  DuplicateConditionButton,
  DuplicateRequirementButton,
  QueryLayout,
  RedoButton,
  UndoButton,
} from 'ui/queryBuilder';
import {
  QueryLayoutProps,
  RedirectButtonProps,
  SingleValueInputProps,
  SingleValueSelectProps,
  VisualComponentsContextState,
} from 'modules/queryBuilder/contexts';
import { CustomUserProfileSelect } from './CustomUserProfileSelect';
import { CustomValueWithCatInSegInput } from './catInSeg/CustomValueWithCatInSegInput';
import { CustomConditionComparatorSelect } from './catInSeg/CustomConditionComparatorSelect';
import { CustomConditionCastTypeSelect } from './CustomConditionCastTypeSelect';
import { CustomConditionFieldSelect } from './CustomConditionFieldSelect';
import { AIQuerySummaryButton } from './ai/AIQuerySummaryButton';

// For string and numeric inputs
const CustomConditionSingleValueInput = (props: SingleValueSelectProps<string>) => {
  return <CustomValueWithCatInSegInput DefaultComponent={ConditionSingleValueInput} {...props} />;
};

// For list select
const CustomConditionValueSingleStringSelectWithButton = (
  props: SingleValueSelectProps<string> & RedirectButtonProps,
) => (
  <CustomValueWithCatInSegInput
    DefaultComponent={ConditionSingleValueStringSelectWithButton}
    {...props}
  />
);

// For other primitive type selects
const CustomConditionValueSingleStringSelect = (props: SingleValueSelectProps<string>) => (
  <CustomValueWithCatInSegInput DefaultComponent={ConditionSingleValueStringSelect} {...props} />
);

const CustomConditionValueDateSelect = (props: SingleValueInputProps<string>) => (
  <CustomValueWithCatInSegInput DefaultComponent={ConditionDatePicker} {...props} />
);

const CustomQueryLayout = (props: QueryLayoutProps) => (
  <QueryLayout AITools={<AIQuerySummaryButton />} {...props} />
);

/**
 * stores custom visual components for queryBuilder
 */
export const queryBuilderVisualComponents: Partial<VisualComponentsContextState> = {
  ConditionValueSingleStringInput: CustomConditionSingleValueInput,
  ConditionValueSingleNumberInput: CustomConditionSingleValueInput,
  ConditionValueSingleStringSelect: CustomConditionValueSingleStringSelect,
  ConditionValueSingleStringSelectWithButton: CustomConditionValueSingleStringSelectWithButton,
  ConditionValueDateSelect: CustomConditionValueDateSelect,
  ConditionComparatorSelect: CustomConditionComparatorSelect,
  ConditionCastTypeSelect: CustomConditionCastTypeSelect,
  UserProfileSelect: CustomUserProfileSelect,
  ConditionFieldSelect: CustomConditionFieldSelect,
  QueryLayout: CustomQueryLayout,
  DuplicateConditionButton,
  DuplicateRequirementButton,
  UndoQueryButton: UndoButton,
  RedoQueryButton: RedoButton,
};
